import React,{useState} from 'react'
import dayjs from 'dayjs';
// import { DemoContainer} from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { DateField } from '@mui/x-date-pickers/DateField';

export default function DateCalander({title}) {
    // const [value, setValue] = React.useState(dayjs('2022-04-17'));
    const [toDate, setTodate] = useState(dayjs(new Date()))
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* <DemoContainer components={['DateCalendar', 'DateCalendar']}>
        <DemoItem label="Uncontrolled calendar">
          <DateCalendar defaultValue={dayjs('2022-04-17')} />
        </DemoItem> 
         <DemoItem >
          <DateCalendar value={value} onChange={(newValue) => setValue(newValue)} />
        </DemoItem>
        <DateTimePicker
          label="Date Time"
          value={value}
          onChange={(newValue) => setValue(newValue)}
        />
      </DemoContainer> */}
      {/* <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}></DemoContainer> */}
        <DatePicker
          label={title} value={toDate} onChange={(newValue) => setTodate(newValue)}
          slotProps={{ textField: { size: 'small' } }}
          format='DD/MM/YYYY'
        />
        {/* <DatePicker sx={{ width: '100%' }} label='Date' shouldDisableDate={shouldDisableDate} disableFuture value={toDate} onChange={(newValue) => setTodate(newValue)} /> */}
        
    </LocalizationProvider>
  );
}
